import { makeStyles, Typography } from "@material-ui/core";
import { Datagrid, ReferenceArrayField, TextField } from "react-admin";
import CustomPagination from "../../../components/CustomPagination";
import React from "react";
import CustomLabeled from "../../../components/layout/CustomLabeled";

interface INotificationTargetReferenceField {
  referenceField: string;
  referenceSourceField: string;
  labelField: string;
  labelSourceField: string;
  pageSize?: number;
  orderBy?: string;
  orderType?: "ASC" | "DESC";
}

const useStyles = makeStyles({
  thead: {
    display: "none",
  },
});

const NotificationTargetReferenceField = ({
  referenceField,
  referenceSourceField,
  labelField,
  labelSourceField,
  pageSize = 10,
  orderBy = "id",
  orderType = "DESC",
}: INotificationTargetReferenceField) => {
  const classes = useStyles();

  return (
    <CustomLabeled name={labelField}>
      <ReferenceArrayField
        reference={referenceField}
        source={referenceSourceField}
        sort={{ field: orderBy, order: orderType }}
        perPage={pageSize}
        pagination={
          <CustomPagination
            limit={<Typography variant="body2">-</Typography>}
          />
        }
      >
        <Datagrid classes={{ thead: classes.thead }}>
          <TextField source={labelSourceField} label="" />
        </Datagrid>
      </ReferenceArrayField>
    </CustomLabeled>
  );
};

export default NotificationTargetReferenceField;
